export default {
  title: 'Copago',
  description: 'Un copago es una cantidad específica en dólares que usted debe pagar por servicios de atención médica o recetas cubiertos, según lo define su plan de seguro.',
  'is-paid': 'está pagado',
}
